import React from 'react'
import BreadCrum from '../components/BreadCrum'
import Container from '../components/Container'
import Meta from '../components/Meta'

const ResetPassword = () => {
    return (
        <>
          <Meta title='Reset Password'/>
          <BreadCrum title='Reset Password' />
          <Container class1="login-wrapper py-5 home-wrapper-2">
            <div className="row">
                <div className="col-12">
                    <div className="auth-card">
                        <h3 className='text-center mb-3'>Reset Password</h3>
                        <p className="text-center mb-3">Enter new password</p>
                        <form action="" className='d-flex flex-column gap-15'>
                            <div>
                                <input type="password" name='password' placeholder='New Password' className="form-control" />
                            </div>
                            <div className='mt-1'>
                                <input type="password" name='password-confirmation' placeholder='Confirm New Password' className="form-control" />
                            </div>
                            <div>
                                <div className="mt-3 d-flex flex-column justify-content-center gap-15 align-items-center">
                                    <button type='submit' className="button border-0">Change Password</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
         </div>
          </Container>
        </>
      )
}

export default ResetPassword